import styled from "@emotion/styled";
import { indentDisc } from "../../../../css-modules/mixin/li";
import {
  grayScale,
  mBody1,
  mBody2,
  mBody4,
  mTitle1,
  swc,
  wBody1,
  wBody2,
  wBody4,
  wTitle1,
  wTitle2,
} from "@teamsparta/design-system";
import { DESKTOP } from "@/themes/device";

export const Wrapper = styled.div`
  position: relative;
  width: 328px;
  ${DESKTOP} {
    width: auto;
  }
`;

export const Title = styled.div<{ isBlackTitle: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  span {
    ${mTitle1};
    margin-top: 3px;
    margin-right: 4px;
    color: ${({ isBlackTitle }) =>
      isBlackTitle ? `${grayScale.gray100}` : `${swc.blue}`} !important;
    ${DESKTOP} {
      ${wTitle1};
      margin-right: 8px;
      font-weight: 700;
    }
  }
  small {
    ${mBody4};
    color: ${swc.blue} !important;
    ${DESKTOP} {
      ${wBody2};
    }
    margin-top: 3px;
  }
`;

export const Label = styled.div<{ isOTweek: boolean; isBlackLabel: boolean }>`
  width: ${({ isOTweek }) => (isOTweek ? `31px` : `24px`)};
  height: 24px;
  background-color: ${({ isBlackLabel }) =>
    isBlackLabel ? `${grayScale.gray100}` : `${swc.blue}`};
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  ${DESKTOP} {
    width: ${({ isOTweek }) => (isOTweek ? `40px` : `32px`)};
    height: 32px;
    margin-right: 24px;
  }

  div {
    ${mBody1};
    color: ${grayScale.white} !important;
    line-height: 1;
    ${DESKTOP} {
      ${mTitle1}
    }
  }
`;

export const GoalContainer = styled.div`
  margin: 16px 0 16px 32px;
  ${DESKTOP} {
    margin: 24px 0 24px 56.15px;
  }
`;

export const GoalLabel = styled.div`
  ${mBody1};
  margin-bottom: 4px;
  ${DESKTOP} {
    ${wTitle2};
    margin-bottom: 8px;
  }
`;

export const Goal = styled.div`
  ${mBody4};
  color: ${grayScale.gray90} !important;
  padding-left: 6px;
  ${DESKTOP} {
    ${wBody4};
    padding-left: 8px;
  }
`;

export const DetailWrapper = styled.div`
  margin-left: 32px;
  padding: 20px 16px 0;
  width: 296px;
  background: ${grayScale.white};
  border: 1px solid ${swc.blue};
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  ${DESKTOP} {
    margin-left: 56.15px;
    width: 620px;
  }
`;

export const DetailHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 19px;
  span {
    ${mBody2};
    color: ${swc.blue} !important;
    ${DESKTOP} {
      ${wBody2}
    }
  }
  &:hover {
    cursor: pointer;
  }
`;

export const DetailContainer = styled.div`
  margin-top: 4px;
`;

export const Detail = styled.div`
  margin-bottom: 16px;
  padding: 16px;
  background: #f2f6f8;
  border-radius: 6px;
  ${DESKTOP} {
    padding: 24px;
  }
  span {
    ${mBody1};
    ${DESKTOP} {
      ${wBody1};
    }
  }

  ul {
    list-style: none;
    padding-inline-start: 0;
    margin-block-start: 8px;
    margin-block-end: 0;
    ${mBody4};
    color: ${grayScale.gray80} !important;
    ${DESKTOP} {
      ${wBody4};
    }
  }
`;

export const CourseTitle = styled.div<{ isNotList: boolean }>`
  margin-top: 10px;
  ul {
    margin-top: 4px;
    li {
      ${indentDisc};
      ${({ isNotList }) =>
        isNotList ? `&:before{display: none}; margin: 0; padding: 0;` : ""}
    }
  }
`;

type pixel = number;
export const Vertical = styled.div<{
  height: pixel;
  idx: number;
  lastStepIdx: number;
}>`
  position: absolute;
  top: 3px;
  left: 11.5px;
  height: ${(props) =>
    props.idx === props.lastStepIdx ? "0" : props.height - 24}px;
  width: 2px;
  background-color: ${grayScale.gray30};
  ${DESKTOP} {
    left: 15px;
  }
`;

export const ToggleWrapper = styled.div<{ isTrue: boolean }>`
  transform: rotateZ(${({ isTrue }) => (isTrue ? 0 : 180)}deg)
    translateY(${({ isTrue }) => (isTrue ? -5 : 0)}px);
`;
